export function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

export function formatCpfCnpj(value: string): string {
  const d = digitsOnly(value).slice(0, 14);
  if (d.length <= 11) {
    return d
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }
  return d
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
}

export function formatCep(value: string): string {
  const d = digitsOnly(value).slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

function allSameDigit(digits: string): boolean {
  return /^(\d)\1+$/.test(digits);
}

function mod11Check(digits: string, weights: number[]): number {
  const sum = weights.reduce((acc, w, i) => acc + Number(digits[i]) * w, 0);
  const rest = sum % 11;
  return rest < 2 ? 0 : 11 - rest;
}

export function isValidCpf(value: string): boolean {
  const d = digitsOnly(value);
  if (d.length !== 11 || allSameDigit(d)) return false;
  const d1 = mod11Check(d, [10, 9, 8, 7, 6, 5, 4, 3, 2]);
  if (d1 !== Number(d[9])) return false;
  const d2 = mod11Check(d, [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);
  return d2 === Number(d[10]);
}

export function isValidCnpj(value: string): boolean {
  const d = digitsOnly(value);
  if (d.length !== 14 || allSameDigit(d)) return false;
  const d1 = mod11Check(d, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  if (d1 !== Number(d[12])) return false;
  const d2 = mod11Check(d, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  return d2 === Number(d[13]);
}

export function isValidCpfCnpj(value: string): boolean {
  const d = digitsOnly(value);
  if (d.length === 11) return isValidCpf(d);
  if (d.length === 14) return isValidCnpj(d);
  return false;
}
